var $ = require('jquery')
  , formUtil = {}
  , VISIBLE_INPUT = "input, button, textarea"
  , TEXTAREA = "textarea"

formUtil.toDict = function(form) {
  var dict = {}
    , array = form.serializeArray()
    , item

  for (var i = 0; i < array.length; i++) {
    item = array[i]
    dict[item.name] = item.value
  }

  return dict
}

formUtil.send = function(form, options) {
  var data = formUtil.toDict(form)
    , method = form.attr("method")
    , action = form.attr('action')

  // The form itself should contains ck, right?
  return $.ajax($.extend({
    type: method
  , url: action
  , data: data
  }, options))
}

formUtil.readonlyForm = function(formOrElements) {
  var elements = formOrElements[
    formOrElements.is('form') ? 'find' : 'filter'
  ](VISIBLE_INPUT)

  elements.each(function(index, el) {
    var element = $(el)
    element.data('prev-disabled-prop', element.prop('disabled'))
  });
  elements.prop('disabled', true);
}

formUtil.resumeForm = function(formOrElements) {
  var elements = formOrElements[
    formOrElements.is('form') ? 'find' : 'filter'
  ](VISIBLE_INPUT)

  elements.each(function(index, el) {
    var element = $(el)
    element.prop('disabled', element.data('prev-disabled-prop'))
  });
}


var ENTER_KEYCODE = 13
formUtil.ctrlEnterForm = function(form) {
  var textarea = form.find(TEXTAREA)

  textarea.keypress(function(e) {
    if (e.keyCode === ENTER_KEYCODE && e.ctrlKey) {
      form.submit()
    }
  })
}

function getTextareaScrollHeight(textarea) {
  // Using scrollTop rather than scrollHeight
  // because scrollHeight is non-standard and includes padding.
  return textarea.height(0).scrollTop(0).scrollTop(10000).scrollTop()
}

formUtil.autoResize = function(textarea) {
  var fakeTextarea = textarea.data('fake-textarea')

  if (!fakeTextarea) { return }

  var value = textarea.val()

  fakeTextarea.val(value)

  var height = getTextareaScrollHeight(fakeTextarea)
    , maxHeight = textarea.data('max-height') || 100
    , minHeight = textarea.data('min-height')

  if (height > maxHeight) {
    height = maxHeight
    textarea.css({'overflow-y': 'auto'})
  }

  textarea.height((height < minHeight) ? minHeight: height)
}

formUtil.enableAutoResize = function(textarea, fakeTextareaParent) {
  var fakeTextarea = textarea.clone()
  fakeTextarea.removeAttr('name')

  fakeTextareaParent = fakeTextareaParent || textarea.parent()

  textarea.data('fake-textarea', fakeTextarea)

  var minHeight = textarea.data('min-height')
  if (!minHeight) {
    textarea.data('min-height', textarea.height())
  }

  textarea.on('input keyup', $.proxy(function(e) {
    if (e && e.originalEvent) {
      var prop = e.originalEvent.propertyName
      if (prop && prop !== 'value') {
        return
      }
    }
    formUtil.autoResize(textarea)
  }, this))

  fakeTextarea.attr({
    'style': 'position: absolute; left: -999px;'
  })

  fakeTextareaParent.append(fakeTextarea)
}

module.exports = formUtil
